import { createFeatureSelector, createSelector } from '@ngrx/store';
import { sessionAuthData } from '../../interfaces/states-data';

export const sessionAuthDataState = createFeatureSelector<sessionAuthData>('sessionAuthState');

export const getSessionAuthData = createSelector(
    sessionAuthDataState,
    (state: sessionAuthData) => state
);
